// Frontend: FromWhere.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import Tiktok from "../images/tiktok.png";
import Instagram from "../images/instagram.png";
import Telegram from "../images/telegram.png";
import Jiji from "../images/jiji.png";
import Afrotie from "../images/afrotie.png";
import Facebook from "../images/facebook.png";
import OldCustomer from "../images/oldCustomer.jpg";
import Recommended from "../images/recommended.png";
import Live from "../images/tiktok live.png";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import CustomerSSidebar from "./CustomerService/components/CustomerSSidebar";

const apiUrl = process.env.REACT_APP_API_URL;

const socialPlatforms = [
  { name: "Tiktok", icon: `${Tiktok}` },
  { name: "Instagram", icon: `${Instagram}` },
  { name: "Telegram", icon: `${Telegram}` },
  { name: "Jiji", icon: `${Jiji}` },
  { name: "Afrotie", icon: `${Afrotie}` },
  { name: "Facebook", icon: `${Facebook}` },
  { name: "Tiktok Live", icon: `${Live}` },
  { name: "OldCustomer", icon: `${OldCustomer}` },
];

const socialPlatforms1 = [
  { name: "Tiktok", icon: `${Tiktok}` },
  { name: "Instagram", icon: `${Instagram}` },
  { name: "Telegram", icon: `${Telegram}` },
  { name: "Jiji", icon: `${Jiji}` },
  { name: "Afrotie", icon: `${Afrotie}` },
  { name: "Facebook", icon: `${Facebook}` },
  { name: "Tiktok Live", icon: `${Live}` },
  { name: "OldCustomer", icon: `${OldCustomer}` },
  { name: "Recommended ", icon: `${Recommended}` },
];

function FromWhere() {
  const [user, setUser] = useState("");
  const [disabledButtons, setDisabledButtons] = useState({});
  const [counts, setCounts] = useState({});
  const [soldCounts, setSoldCount] = useState({});
  const [timeframe, setTimeframe] = useState("daily");
  const [customMonth, setCustomMonth] = useState(new Date().getMonth() + 1);
  const [customYear, setCustomYear] = useState(new Date().getFullYear());

  useEffect(() => {
    setUser(localStorage.getItem("role"));
  }, []);

  const buildQuery = () => {
    if (timeframe === "custom") {
      return `timeframe=custom&month=${customMonth}&year=${customYear}`;
    }
    return `timeframe=${timeframe}`;
  };

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const res = await axios.get(`${apiUrl}/api/referrals?${buildQuery()}`);
        setCounts(res.data);
      } catch (err) {
        console.error("Failed to fetch counts", err);
      }
    };
    fetchCounts();
  }, [timeframe, customMonth, customYear]);

  useEffect(() => {
    const fetchSoldCounts = async () => {
      try {
        const res = await axios.get(
          `${apiUrl}/api/soldReferrals?${buildQuery()}`
        );
        setSoldCount(res.data);
      } catch (err) {
        console.error("Failed to fetch sold counts", err);
      }
    };
    fetchSoldCounts();
  }, [timeframe, customMonth, customYear]);

  return (
    <>
      <Header />
      {user === "Admin" ? <Sidebar /> : <CustomerSSidebar />}

      <div className="mt-28 px-4">
        {/* CALLS */}
        <div className="flex flex-row items-center justify-around mb-4">
          <div className="bg-white rounded shadow-lg px-10 p-6">
            <h2 className="text-xl font-bold mb-4 p-4">
              Where are they CALLING from?
            </h2>
            <div className="grid grid-cols-3 gap-6">
              {socialPlatforms.map((platform) => (
                <button
                  key={platform.name}
                  onClick={async () => {
                    setDisabledButtons((prev) => ({
                      ...prev,
                      [platform.name]: true,
                    }));
                    try {
                      const res = await axios.post(
                        `${apiUrl}/api/referrals/increment`,
                        {
                          platform: platform.name,
                        }
                      );
                      setCounts((prev) => ({
                        ...prev,
                        [platform.name]: res.data.count,
                      }));
                    } catch (err) {
                      console.error("Error incrementing", err);
                    } finally {
                      setDisabledButtons((prev) => ({
                        ...prev,
                        [platform.name]: false,
                      }));
                    }
                  }}
                  disabled={disabledButtons[platform.name]}
                  className={`flex flex-col items-center p-3 rounded shadow ${
                    disabledButtons[platform.name]
                      ? "bg-gray-300 cursor-not-allowed"
                      : "bg-white hover:bg-gray-100"
                  }`}
                >
                  <img
                    src={platform.icon}
                    alt={platform.name}
                    className="w-10 h-10"
                  />
                  <span className="mt-2 text-sm">{platform.name}</span>
                  <span className="font-semibold">
                    {counts[platform.name] || 0}
                  </span>
                </button>
              ))}
            </div>
          </div>
          <div className=" p-4 bg-white shadow-md rounded">
            <div className="mb-4 flex gap-2 flex-wrap">
              {["daily", "weekly", "monthly", "yearly", "custom"].map(
                (frame) => (
                  <button
                    key={frame}
                    onClick={() => setTimeframe(frame)}
                    className={`px-3 py-1 rounded ${
                      timeframe === frame
                        ? "bg-blue-600 text-white"
                        : "bg-gray-200"
                    }`}
                  >
                    {frame.charAt(0).toUpperCase() + frame.slice(1)}
                  </button>
                )
              )}
            </div>

              {timeframe === "custom" && (
                <div className="mb-4 flex gap-4">
                  <select
                    value={customMonth}
                    onChange={(e) => setCustomMonth(Number(e.target.value))}
                    className="border p-2 rounded"
                  >
                    {Array.from({ length: 12 }, (_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {new Date(0, i).toLocaleString("default", {
                          month: "long",
                        })}
                      </option>
                    ))}
                  </select>
                  <select
                    value={customYear}
                    onChange={(e) => setCustomYear(Number(e.target.value))}
                    className="border p-2 rounded"
                  >
                    {[2022, 2023, 2024, 2025].map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            <div className="mt-6">
              <h3 className="text-lg font-semibold mb-2">
                {timeframe.charAt(0).toUpperCase() + timeframe.slice(1)} Summary
              </h3>
              <ul className="bg-white rounded shadow p-4 space-y-2">
                {socialPlatforms.map((platform) => (
                  <li
                    key={platform.name}
                    className="flex items-center justify-between border-b last:border-none pb-2"
                  >
                    <div className="flex items-center gap-2">
                      <img
                        src={platform.icon}
                        alt={platform.name}
                        className="w-5 h-5"
                      />
                      <span>{platform.name}</span>
                    </div>
                    <span className="font-semibold">
                      {counts[platform.name] || 0}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* sold referrals */}
  
        <div className="flex flex-row items-center justify-around mb-4 mt-6">
          <div className="bg-gray-100 rounded shadow-lg px-10 p-6">
            <h2 className="text-xl font-bold mb-4 p-4">
              Where are they BUYING from?
            </h2>
            <div className="grid grid-cols-3 gap-6">
              {socialPlatforms1.map((platform) => (
                <button
                  key={platform.name}
                  onClick={async () => {
                    setDisabledButtons((prev) => ({
                      ...prev,
                      [platform.name]: true,
                    }));
                    try {
                      const res = await axios.post(
                        `${apiUrl}/api/soldReferrals/increment`,
                        {
                          platform: platform.name,
                        }
                      );
                      setSoldCount((prev) => ({
                        ...prev,
                        [platform.name]: res.data.count,
                      }));
                    } catch (err) {
                      console.error("Error incrementing", err);
                    } finally {
                      setDisabledButtons((prev) => ({
                        ...prev,
                        [platform.name]: false,
                      }));
                    }
                  }}
                  disabled={disabledButtons[platform.name]}
                  className={`flex flex-col items-center p-3 rounded shadow ${
                    disabledButtons[platform.name]
                      ? "bg-gray-300 cursor-not-allowed"
                      : "bg-gray-200 hover:bg-gray-100"
                  }`}
                >
                  <img
                    src={platform.icon}
                    alt={platform.name}
                    className="w-10 h-10"
                  />
                  <span className="mt-2 text-sm">{platform.name}</span>
                  <span className="font-semibold">
                    {soldCounts[platform.name] || 0}
                  </span>
                </button>
              ))}
            </div>
          </div>
          <div className=" p-4 bg-gray-100 shadow-md rounded">
            <div className="mb-4 flex gap-2 flex-wrap">
              {["daily", "weekly", "monthly", "yearly", "custom"].map(
                (frame) => (
                  <button
                    key={frame}
                    onClick={() => setTimeframe(frame)}
                    className={`px-3 py-1 rounded ${
                      timeframe === frame
                        ? "bg-blue-600 text-white"
                        : "bg-gray-200"
                    }`}
                  >
                    {frame.charAt(0).toUpperCase() + frame.slice(1)}
                  </button>
                )
              )}
            </div>
              {timeframe === "custom" && (
                <div className="mb-4 flex gap-4">
                  <select
                    value={customMonth}
                    onChange={(e) => setCustomMonth(Number(e.target.value))}
                    className="border p-2 rounded"
                  >
                    {Array.from({ length: 12 }, (_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {new Date(0, i).toLocaleString("default", {
                          month: "long",
                        })}
                      </option>
                    ))}
                  </select>
                  <select
                    value={customYear}
                    onChange={(e) => setCustomYear(Number(e.target.value))}
                    className="border p-2 rounded"
                  >
                    {[2022, 2023, 2024, 2025].map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>
              )}
            <div className="mt-6">
              <h3 className="text-lg font-semibold mb-2">
                {timeframe.charAt(0).toUpperCase() + timeframe.slice(1)} Summary
              </h3>
              <ul className="bg-gray-100 rounded shadow p-4 space-y-2">
                {socialPlatforms1.map((platform) => (
                  <li
                    key={platform.name}
                    className="flex items-center justify-between border-b last:border-none pb-2"
                  >
                    <div className="flex items-center gap-2">
                      <img
                        src={platform.icon}
                        alt={platform.name}
                        className="w-5 h-5"
                      />
                      <span>{platform.name}</span>
                    </div>
                    <span className="font-semibold">
                      {soldCounts[platform.name] || 0}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FromWhere;
